// Setter tracking (SPEC §19, 2026-10-01): the dial-screen state a presence beat reports. Pure (no store, no DOM) so the
// worker-side test project can import it (tests/trk-web.test.ts). Owner: tracking agent.
import { LIVE_PHASES, type CallPhase } from '../dialer/machine';
import type { PresenceState } from '../../../src/shared/api-tracking';

export function presenceStateOf(s: { view: 'picker' | 'lead'; call: { phase: CallPhase } }): PresenceState {
  if (LIVE_PHASES.includes(s.call.phase)) return 'in_call';
  if (s.call.phase === 'ended' || s.call.phase === 'needs_disposition') return 'wrap';
  if (s.view === 'lead') return 'ready';
  return 'paused';
}
